import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ButtonComponent, IButtonConfig } from 'shared/components/atoms/button/button.component';
import { ButtonShape, ButtonSize, ButtonStyle } from 'shared/enums';

@Component({
  selector: 'app-table-actions',
  templateUrl: './table-actions.component.html',
  styles: `
    :host {
      width: 100%;
    }

    :host-context(.stretch) {
      .button-container {
        flex-grow: 1;

        app-button {
          ::ng-deep .mdc-button {
            width: 100%;
          }
        }
      }
    }
  `,
  imports: [MatTooltip, TranslateModule, ButtonComponent, NgClass],
})
export class TableActionsComponent<T> implements ICellRendererAngularComp {
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonShape = ButtonShape;

  public params!: Partial<ICellRendererParams<T>>;
  public buttonData: ITableActionButtonConfig<T>[] = [];

  // ICellRendererAngularComp implementation
  public agInit(params: ICellRendererParams<T>): void {
    this.params = params;
    this.buttonData = this.getButtonData();
  }

  public refresh(params: ICellRendererParams<T>): boolean {
    this.params = params;
    this.buttonData = this.getButtonData();
    return true;
  }

  public getText(button: ITableActionButtonConfig<T>): string {
    if (typeof button.text === 'function') {
      return button.text(this.params.data);
    }

    return button.text || '';
  }

  private getButtonData(): ITableActionButtonConfig<T>[] {
    if (this.params.context?.buttonsFn) {
      return this.params.context.buttonsFn(this.params);
    }
    if (this.params.context?.buttons) {
      return this.params.context.buttons;
    }
    return [];
  }
}

export interface ITableActionButtonConfig<T> extends Omit<IButtonConfig, 'text' | 'action'> {
  hide?: boolean | ((rowData: T | undefined) => boolean);
  text?: string | ((rowData: T | undefined) => string);
  action: (rowData: T | undefined) => void;
}
